export const ERROR_MESSAGES = {
  DEFAULT: 'Something went wrong. Please try again.!',

  // VIEW COACHEE REVIEW
  NO_REVIEWS_IN_THE_SESSION: 'No reviews exists in the session!',
  NOT_ADDED_REVIEW: 'Coachee is not addedd a review!'
}
